import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { IUser } from '@interfaces/IUser';
import { IUsersGroup } from '@interfaces/IUsersGroup';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class UsersService {
  url = environment.baseUrl + 'api/v1/users/';

  constructor(private _http: HttpClient, private _router: Router) {}

  register(user: IUser): Observable<IUser> {
    const url = this.url;
    return this._http.post<IUser>(url, user);
  }

  importUsers(data: FormData): Observable<{
    detail: string;
    skipped: { users: string[]; text: string };
  }> {
    const url = `${this.url}import/`;
    return this._http.post<{
      detail: string;
      skipped: { users: string[]; text: string };
    }>(url, data);
  }

  confirm_user(id: number): Observable<{ detail: string }> {
    const url = `${this.url}confirm/`;
    return this._http.patch<{ detail: string }>(url, { user_id: id });
  }

  editUser(
    id: number,
    userData: IUser
  ): Observable<{ user: IUser; detail: string }> {
    const url = `${this.url + id}/`;
    return this._http.put<{ user: IUser; detail: string }>(url, userData);
  }

  getUsers(queries?: {
    [key: string]: string;
  }): Observable<{ count: number; results: IUser[] }> {
    const url = this.url;
    return this._http.get<{ count: number; results: IUser[] }>(url, {
      params: queries,
    });
  }

  getUser(id: number): Observable<IUser> {
    const url = `${this.url + id}/`;
    return this._http.get<IUser>(url);
  }

  deleteUser(id: number): Observable<IUser> {
    const url = `${this.url + id}/`;
    return this._http.delete<IUser>(url);
  }

  getGroups(): Observable<IUsersGroup[]> {
    const url = `${this.url}groups/`;
    return this._http.get<IUsersGroup[]>(url);
  }

  createUser(user: IUser): Observable<IUser> {
    const url = `${this.url}create/`;
    return this._http.post<IUser>(url, user);
  }

  getUnconfirmedCount(): Observable<{ count: number }> {
    const url = `${this.url}unconfirmed-count/`;
    return this._http.get<{ count: number }>(url);
  }
}
